import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class dmRoom {
    RoomID:       number;
    RoomNumber:   string;

    SkipNextCall: boolean;

    Room:         RQService.Pms.GetRoomsRow;

    constructor(
        pRoom: RQService.Pms.GetRoomsRow
    ) {
        this.RoomID       = pRoom.RoomID;
        this.RoomNumber   = pRoom.RoomNumber;

        this.SkipNextCall = false;

        this.Room         = pRoom;
    }
}

export class RoomsViewModel {
    BackToSignIn:   ()                                 => void;
    NewLoading:     (pMessage: string)                 => dmLoading;
    ShowAlert:      (pTitle: string, pMessage: string) => void;
    FocusNext:      (pIndex: number)                   => void;

    mlText:         MLText;
    app:            mlBroker;
    ml:             mlBroker;
    Hotel:          dmHotel;
    LangID:         number;
    RoomName:       string;
    SelectedBaseID: number;
    InAction:       boolean; 
    InRefresh:      boolean;
    RoomNumber:     string;
    Placeholder:    string;
    RoomTypeID:     number;

    RoomTypes:      RQService.Pms.GetRoomTypesRow[];
    HRooms:         RQService.Pms.GetRoomsRow[];
    HRoomsByID:     dmRoom[];

    constructor(
         pMLText:           MLText
        ,pHotel:            dmHotel
        ,pBackToSignIn:     ()                                 => void
        ,pNewLoading:       (pMessage: string)                 => dmLoading
        ,pShowAlert:        (pTitle: string, pMessage: string) => void
        ,pFocusNext:        (pIndex: number)                   => void
    ) {
        this.mlText         = pMLText;
        this.LangID         = this.mlText.GetLangID();
        this.app            = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml             = this.mlText.GetBroker(
            'CTMExtranetRooms'
        );

        this.Hotel          = pHotel;
        this.BackToSignIn   = pBackToSignIn;
        this.NewLoading     = pNewLoading;
        this.ShowAlert      = pShowAlert;
        this.FocusNext      = pFocusNext;

        this.HRooms         = [];
        this.HRoomsByID     = [];

        this.SelectedBaseID = 1;
        this.RoomTypes      = [];
        this.RoomNumber     = '';
        this.RoomTypeID     = 0;
        this.Placeholder    = this.ml.Text(
             'EnterRoomNumber'
            ,'Enter Room Number'
        );

        let loading         = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')              
        );

        this.InAction       = true;
        this.InRefresh      = false;

        loading.Show(() => {
            let RTParams     = RQParam.PmsGetRoomTypesParams();

            RTParams.HotelID = this.Hotel.HotelID;
            RTParams.LangID  = this.LangID;          
       
            RQService.Pms.GetRooms(RTParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                let rooms = response.RQueryResult;

                for (let i = 0; i < rooms.length; i++) {
                    let room = RQService.Pms.PopulateGetRoomsRow(
                        rooms[i]
                    );

                    this.HRoomsByID[room.RoomID] = new dmRoom(room);
                    
                    this.HRooms.push(room);
                }

                RQService.Pms.GetRoomTypes(RTParams).then((result) => {
                    let response = result as any;

                    if (response.HasErrorOrException) { loading.Dismiss(); return; }

                    let baseNames = response.RQueryResult;

                    for (let i = 0; i < baseNames.length; i++) {
                        let baseName = RQService.Pms.PopulateGetRoomTypesRow(
                            baseNames[i]
                        );

                        this.RoomTypes.push(baseName);
                    }

                    loading.Dismiss();
                });
            });            
        });
        
    };

    public AddNewRoom() {
        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let addParams = RQParam.PmsNewRoomParams();

            addParams.HotelID    = this.Hotel.HotelID;
            addParams.LangID     = this.LangID;
            addParams.RoomNumber = this.RoomNumber;
            addParams.RoomTypeID = this.RoomTypeID;

            RQService.Pms.NewRoom(addParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }
                
                this.refreshList(() => { loading.Dismiss(); });
            });
        });
    }

    public EditRoom(
         pEvent:        Event
        ,pRoom:         RQService.Pms.GetRoomsRow
        ,pIndex:        number
        ,pSkipNextCall: boolean
    ) {
        if (
            this.HRoomsByID[pRoom.RoomID]
        &&  this.HRoomsByID[pRoom.RoomID].SkipNextCall
        ) {
            this.HRoomsByID[pRoom.RoomID].SkipNextCall = false;

            return;
        }

        if (
            this.HRoomsByID[pRoom.RoomID]
        &&  pSkipNextCall
        ) {
            this.HRoomsByID[pRoom.RoomID].SkipNextCall = true;
        }

        if (pRoom.RoomNumber.trim() == '') {
            if (this.HRoomsByID[pRoom.RoomID]) {
                this.HRoomsByID[pRoom.RoomID].Room.RoomNumber = this.HRoomsByID[
                    pRoom.RoomID
                ].RoomNumber;
            }

            if (pSkipNextCall) {
                pEvent.preventDefault();

                this.FocusNext(pIndex);
            }

            return;
        }

        if (
            this.HRoomsByID[pRoom.RoomID]
        &&  pRoom.RoomNumber.trim() == this.HRoomsByID[pRoom.RoomID].RoomNumber
        ) {
            this.HRoomsByID[pRoom.RoomID].Room.RoomNumber = this.HRoomsByID[
                pRoom.RoomID
            ].RoomNumber;


            if (pSkipNextCall) {
                pEvent.preventDefault();

                this.FocusNext(pIndex);
            }

            return;
        }

        let addParams = RQParam.PmsEditRoomParams();

        addParams.HotelID    = this.Hotel.HotelID;
        addParams.LangID     = this.LangID;
        addParams.RoomID     = pRoom.RoomID;
        addParams.RoomNumber = pRoom.RoomNumber.trim();

        console.log(
            "RoomNumber Edit:" + pRoom.RoomID + ' ' + pRoom.RoomNumber
        );

        RQService.Pms.EditRoom(addParams).then((result) => {
            let response = result as any;                

            if (response.HasErrorOrException) {
                if (this.HRoomsByID[pRoom.RoomID]) {
                    this.HRoomsByID[pRoom.RoomID].Room.RoomNumber =
                        this.HRoomsByID[pRoom.RoomID].RoomNumber;
                }

                this.refreshList(() => { });

                return;
            }

            if (pSkipNextCall) {
                pEvent.preventDefault();

                this.FocusNext(pIndex);
            }
        });
    }

    public ShuffleRoomOrder(
         RoomID:     number
        ,SortOrder:  number
        ,UpDownType: number
    ) {
        let loading = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        loading.Show(() => {
            let addParams            = RQParam.PmsShuffleRoomOrderParams();
            addParams.SortOrderBegin = SortOrder;
            addParams.SortOrderEnd   = SortOrder;
            addParams.HotelID        = this.Hotel.HotelID;
            addParams.LangID         = this.LangID;
            addParams.Up             = ((UpDownType) ? 0 : 1)

            console.log('RoomID: ' + RoomID + ' SortOrder: ' + SortOrder + ' udt: ' + UpDownType);

            RQService.Pms.ShuffleRoomOrder(addParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }
               
                this.refreshList(() => { loading.Dismiss(); });
            });
        });
    }

    public DeleteRoom(RoomID: number) {
        let loading = this.NewLoading(
            this.app.Text('DeletingMark', 'Deleting...')
        );

        loading.Show(() => {
            let addParams = RQParam.PmsDeleteRoomParams();

            addParams.HotelID = this.Hotel.HotelID;
            addParams.LangID  = this.LangID;
            addParams.RoomID  = RoomID;           

            RQService.Pms.DeleteRoom(addParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }
                
                this.refreshList(() => { loading.Dismiss(); });
            });
        });
    }

    public SetRoomType(
         RoomID:     number
        ,RoomTypeID: number
    ): void {
        console.log('Set RT RTID:');
        console.log(RoomTypeID);

        let loading = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        this.InAction = true;

        loading.Show(() => {
            let addParams = RQParam.PmsMigrateRoomParams();

            addParams.HotelID    = this.Hotel.HotelID;
            addParams.LangID     = this.LangID;
            addParams.RoomID     = RoomID;
            addParams.RoomTypeID = RoomTypeID;

            RQService.Pms.MigrateRoom(addParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                this.refreshList(() => { loading.Dismiss(); });
            });
        });
    }

    private refreshList(pAction: () => void): void {
        if (this.InRefresh) { pAction(); return; }

        this.InRefresh         = true;

        let RTParams           = RQParam.PmsGetRoomTypesParams();

        RTParams.HotelID       = this.Hotel.HotelID;
        RTParams.LangID        = this.LangID;

        this.RoomTypes.length  = 0;
        this.HRooms.length     = 0;
        this.HRoomsByID.length = 0;

        RQService.Pms.GetRooms(RTParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { this.InRefresh = false; pAction(); return; }

            let rooms = response.RQueryResult;

            for (let i = 0; i < rooms.length; i++) {
                let room = RQService.Pms.PopulateGetRoomsRow(
                    rooms[i]                    
                );

                this.HRoomsByID[room.RoomID] = new dmRoom(room);

                this.HRooms.push(room);
            }

            RQService.Pms.GetRoomTypes(RTParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { this.InRefresh = false; pAction(); return; }

                let baseNames = response.RQueryResult;

                for (let i = 0; i < baseNames.length; i++) {
                    let baseName = RQService.Pms.PopulateGetRoomTypesRow(
                        baseNames[i]
                    );

                    this.RoomTypes.push(baseName);
                }

                pAction();

                this.InRefresh = false;
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/rooms/xv-rooms.ts